module.exports = __webpack_public_path__ + "img/tabar_withdrawBankCard2.a87ee9a2.png";